var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8629 6.03819C22.0743 11.0907 21.2179 17.3422 16.9361 20.0397C12.6971 22.6944 6.65973 20.8104 3.49119 15.7579C0.279827 10.7054 1.13619 4.45392 5.418 1.75638C9.657 -0.941164 15.6944 0.985651 18.8629 6.03819Z",
    fill: "url(#paint0_linear_1_271)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0926 6.50946C20.9614 11.0482 20.1907 16.7002 16.3799 19.098C12.569 21.5386 7.13114 19.8259 4.26233 15.2872C1.39351 10.7485 2.16424 5.09647 5.97505 2.65583C9.78586 0.25802 15.2238 1.97074 18.0926 6.50946Z",
    fill: "url(#paint1_linear_1_271)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12049 16.6144C-1.09087 11.5618 -0.234508 5.31038 4.0473 2.61284L5.41748 1.75648C1.13567 4.45402 0.279308 10.7055 3.49067 15.758C6.65921 20.8105 12.6966 22.6945 16.9356 20.0398L15.5654 20.8962C11.3264 23.5937 5.28903 21.6669 2.12049 16.6144Z",
    fill: "url(#paint2_linear_1_271)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84755 2.74146C5.90464 2.71292 5.94746 2.68438 5.97601 2.65583C9.78682 0.25802 15.2247 1.97074 18.0935 6.50947C20.9623 11.0482 20.1916 16.7002 16.3808 19.098C16.3523 19.1265 16.3094 19.1551 16.2524 19.1836C19.9775 16.743 20.7054 11.1766 17.8794 6.68074C15.0106 2.18483 9.70118 0.429284 5.84755 2.74146Z",
    fill: "#7E470D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_271",
    x1: 20.1046,
    y1: 18.2414,
    x2: 11.2841,
    y2: 23.8505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_271",
    x1: -6.4422,
    y1: 10.149,
    x2: 11.6699,
    y2: -1.32625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_271",
    x1: 7.47275,
    y1: 25.3921,
    x2: -3.10333,
    y2: 8.69302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin13);
export default __webpack_public_path__ + "static/media/coin13.893d0519e74b600f31c1d21de04b0298.svg";
export { ForwardRef as ReactComponent };